import {
  FilterMode,
  MusicalGenreCreateMutationVariables,
  MusicalGenre_OrderBy,
  MusicalGenre,
  SortOrder,
  MusicalGenre_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const musicalGenreService = {
  createOne: buildCreateOne(
    (musicalGenreCreateVariables: MusicalGenreCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.musicalGenreCreate(
          musicalGenreCreateVariables
        );
        return result.musicalGenreCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.musicalGenreOne({ id });
    return result.musicalGenreOne as MusicalGenre;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: MusicalGenre_OrderBy[] | null = null,
    filter: MusicalGenre_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: MusicalGenre_Filter | undefined;
    if (searchValue !== "") {
      where = { name: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.musicalGenreListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ name: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.musicalGenreListWithOffset
    ) as MusicalGenre[];
    return { list, orderBy };
  },
};
